var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/submissions/components/SubmissionForm/SubmissionFormContributorsItem.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/submissions/components/SubmissionForm/SubmissionFormContributorsItem.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"SubmissionFormContributorsItem ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email")) {
t_5 += "SubmissionFormContributorsItem--empty";
;
}
else {
t_5 += "SubmissionFormContributorsItem--filled";
;
}
t_5 += "\">\n        <input type=\"hidden\" value=\"";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id")) {
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"id"), env.opts.autoescape);
;
}
t_5 += "\" name=\"id\">\n\n        <input class=\"SubmissionFormContributorsItem-email SubmissionFormElement-input\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email")) {
t_5 += "readonly";
;
}
t_5 += " name=\"email\" type=\"text\" ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email")) {
t_5 += "value=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"email"), env.opts.autoescape);
t_5 += "\"";
;
}
t_5 += " placeholder=\"Enter e-mail address\">\n\n        <div class=\"SubmissionFormContributorsItem-invite\">ADD CONTRIBUTOR</div>\n\n        <div class=\"SubmissionFormElement-delete\">\n            <div class=\"SubmissionFormElement-deleteItem\"></div>\n            <div class=\"SubmissionFormElement-deleteItem\"></div>\n        </div>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("SubmissionFormContributorsItem");
context.setVariable("SubmissionFormContributorsItem", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/submissions/components/SubmissionForm/SubmissionFormContributorsItem.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/SubmissionForm/SubmissionFormContributorsItem.jinja
// module id = 21
// module chunks = 0